import RomanceImg from './../images/genre-1.webp';
import ActionImg from './../images/genre-2.webp';
import MystryImg from './../images/genre-3.webp';
import FanatsyImg from './../images/genre-4.webp';
import HFictionImg from './../images/genre-5.webp';
import HorrorImg from './../images/genre-6.webp';
import BioImg from './../images/genre-7.webp';
import ChildImg from './../images/genre-8.webp';
import AdultImg from './../images/genre-9.webp';
import LiteraryImg from './../images/genre-10.webp';
import NonFictionImg from './../images/genre-11.webp';
import ScienceImg from './../images/genre-12.webp';


const data = [
    {
        title: "Perfect",
        imgUrl: RomanceImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: HorrorImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Perfect",
        imgUrl: ScienceImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: NonFictionImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Perfect",
        imgUrl: AdultImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: LiteraryImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Perfect",
        imgUrl: ChildImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: BioImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Perfect",
        imgUrl: HFictionImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: FanatsyImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Perfect",
        imgUrl: MystryImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    },
    {
        title: "Alone Times",
        imgUrl: ActionImg,
        author: "ED Sheren",
        downloadUrl: "https://google.com"
    }
]

export default data;